import React, { Component } from 'react';

import Form from './Form/Form';
import Css from './LetsConnectMobile.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class LetsConnectMobile extends Component {
  state = {
    showForm: false,
    areaHeight: window.innerHeight - 54 - 30,
    status: 0
  };

  componentDidMount = () => {
    window.addEventListener(
      'marketo-submitted-lets-connect',
      this.formSubmitted,
      true
    );
    window.addEventListener(
      'marketo-submitting-lets-connect',
      this.formSubmitting,
      true
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener(
      'marketo-submitted-lets-connect',
      this.formSubmitted,
      true
    );
    window.removeEventListener(
      'marketo-submitting-lets-connect',
      this.formSubmitting,
      true
    );
  };

  formSubmitted = () => {
    this.submitingHandler(2);
  };

  formSubmitting = () => {
    this.submitingHandler(1);
  };

  toggleClickHandler = () => {
    const showForm = this.state.showForm;

    const areaHeight = window.innerHeight - 54 - 30;
    this.setState({
      showForm: !showForm,
      areaHeight: areaHeight,
      status: 0
    });
  };

  submitingHandler = status => {
    console.log('Status: ' + status);
    this.setState({
      status: status
    });

    if (status === 2) {
      setTimeout(() => this.toggleClickHandler(), 2000);
    }
  };

  triggerEvents = () => {
    window.gtag('event', 'click', {
      event_category: 'general',
      event_label: "Let's Connect - Phone Number Click (Mobile)"
    });
    window.gtag_report_conversion('tel:866-779-7770');
  };

  render() {
    return (
      <React.Fragment>
        <div
          id={'lets-connect-mobile'}
          className={Css['toggle-bar']}
          onClick={() => this.toggleClickHandler()}
        >
          {this.state.showForm ? (
            <FontAwesomeIcon icon={['far', 'angle-up']} />
          ) : (
            <FontAwesomeIcon icon={['far', 'angle-down']} />
          )}
          <span className={Css.title + ' asap-bold'}>Let's Connect</span>
          <a href="tel:+18667797770" onClick={this.triggerEvents}>
            866.779.7770
          </a>
        </div>

        {this.state.status === 1 && (
          <div
            className={
              Css.loader + ' d-flex align-items-center justify-content-center'
            }
          >
            <div className={'text-center'}>
              <div>
                <FontAwesomeIcon icon={['far', 'spinner']} spin />
              </div>
              Submitting ...
            </div>
          </div>
        )}

        {this.state.status === 2 && (
          <div
            className={
              Css.loader + ' d-flex align-items-center justify-content-center'
            }
          >
            <div className={'text-center'}>
              <div>
                <FontAwesomeIcon icon={['far', 'check-circle']} />
              </div>
              Submited!
            </div>
          </div>
        )}

        {this.state.showForm && (
          <Form {...this.state} click={this.toggleClickHandler} />
        )}
      </React.Fragment>
    );
  }
}

export default LetsConnectMobile;



// WEBPACK FOOTER //
// ./src/components/LetsConnectMobile/LetsConnectMobile.js